module.exports = __webpack_public_path__ + "Roboto-300.7e2d32e7141050d758a3.woff";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src634836211/src/src/assets/fonts/roboto/fonts/Roboto-300/Roboto-300.woff
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-300/Roboto-300.woff
// module chunks = main styles